import includes from 'lodash/includes';
import {createSelector} from 'reselect';
import * as ResourceApi from 'api/resources';
import FilterOperators from 'classes/FilterOperators';
import {
  createResourceNamedFiltersSelector,
  createResourceRawFiltersSelector,
  createResourceSortOptionsSelector
} from 'viewOptions/selectors';

export const getNamedPrizeFilters = createResourceNamedFiltersSelector(ResourceApi.Types.Prize);

export const getRawPrizeFilters = createResourceRawFiltersSelector(ResourceApi.Types.Prize);

export const getPrizeSortOptions = createResourceSortOptionsSelector(ResourceApi.Types.Prize);

export const getPrizeDateRangeBounds = createSelector(
  getRawPrizeFilters,
  filters => filters.reduce((result, filter) => {
    if (filter.field === 'endTime' && filter.operator === FilterOperators.GreaterThanOrEqual) {
      result.lowerBound = filter.value;
    } else if (includes(['startTime', 'endTime'], filter.field) && filter.operator === FilterOperators.LessThanOrEqual) {
      result.upperBound = filter.value;
    }

    return result;
  }, {})
);



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/selectors.js